export const THEME_CLASS_NAMES = {
  secondary: 'secondary'
};

export const TYPE_CLASS_NAMES = {
  sm: 'btnSm'
};
